import type { FaireProductEntity } from "../../entity_types/product";

export const p_fehh7weeze: FaireProductEntity = {
  token: "p_fehh7weeze",
  type: "product",
  name: "Love and Bear Theme Kids Layering Bracelet Set",
  brandToken: "b_bya786doke",
  brandName: "Love and Repeat",
  imageUrl:
    "https://cdn.faire.com/fastly/d4e07890a05e057ac9bf7f8abe297acdfbf166d2ec27b4674fd1b1e41f13b8bb.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/0c7996213883cf3e153bb6510aebca9acaf61c38c4b1794396e9c132fadd2f48.jpeg",
    "https://cdn.faire.com/fastly/c71bb5860f1c87ea43b31067a554645b60ae4e18e9278f20160c8ff0a9f21008.jpeg",
    "https://cdn.faire.com/fastly/fb96b578ede6114cc7587288a9b6e23f5b5ce2be88055d6197b84aad7844c797.jpeg",
    "https://cdn.faire.com/fastly/8d3988ee3533307a229c5ceb0239652f3f1e2c9454f2fc7998b68e27f427a76c.jpeg",
    "https://cdn.faire.com/fastly/6e64b931bf2cfe0eb713943fde7220b4c47cbfb791909d18be1dd63db487cbdb.jpeg",
  ],
  priceDollars: 0.95,
  description:
    "Love and Bear Theme Kids Layering Bracelet Set\r\n\r\n-Each bracelet is designed with an inspirational message, serving as a daily reminder to stay positive and spread happiness. With these bracelets, you can not only uplift your own spirits but also share the joy with your friends, creating a bond of happiness and hope.\r\n",
  tags: [],
  msrpDollars: 1.9,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:51:41.344Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
